import { Component, OnInit, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {


  public tccno : string;
  public login : boolean;
  constructor(private router:Router, private authservice:AuthService) { }

  ngOnInit() {
    this.login = this.authservice.authenticated;
  }
  onSubmit(){
     //console.log(this.tccno);
     this.router.navigate(['/tracking',this.tccno]);
  }
  logout(){
    this.login = false;
    this.authservice.loggedOut();

  }
}
